




























import Vue from "vue";
import Component from "vue-class-component";

@Component({
  components: {},
})
export default class UnitStats extends Vue {
  private events: number = 0;
  private signups: number = 0;
  private players: number = 0;

  async getStats() {
    const response = await this.axios.get("arma/stats");

    this.events = response.data.events;
    this.signups = response.data.signups;
    this.players = response.data.players;
  }

  async created() {
    this.getStats();
  }
}
